import { createContext, useContext } from "react";

export type CellFocusContextValue = {
  /**
   * Whether the cell currently has focus
   */
  isCellFocused: boolean;
};

/**
 * Context for communicating cell focus state to child components.
 * Used by CellStatus to show tooltips when the cell is focused via keyboard.
 */
export const CellFocusContext = createContext<CellFocusContextValue | null>(
  null,
);

/**
 * Hook to consume the CellFocusContext.
 * Returns null if used outside of a CellFocusContext.Provider.
 */
export function useCellFocusContext(): CellFocusContextValue | null {
  return useContext(CellFocusContext);
}
